import { useState, useEffect } from 'react';

import {
  Flex,
  Text,
  Portal,
  Dialog,
  Input,
  Button,
  Box,
  Field,
} from '@chakra-ui/react';

import { SelectField } from '../common';

const Close_Button_value = '✕';

export const FuelTankDialog = ({
  isOpen,
  setIsOpen,
  onClose,
  onSubmit,
  type = 'main',
  isEdit = false,
  cardsCollection,
  initialValues = {
    name: '',
    capacity: '',
    threshold: '',
    movingCard: '',
  },
}) => {
  const [form, setForm] = useState(initialValues);
  const [touched, setTouched] = useState({ movingCard: false });

  useEffect(() => {
    setForm(initialValues);
  }, [initialValues, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (val) => {
    setForm((prev) => ({ ...prev, movingCard: val }));
    setTouched((t) => ({ ...t, movingCard: true }));
  };

  const getNameError = (value) => (!value ? 'Поле обов’язкове' : '');
  const getCapacityError = (value) =>
    !value || isNaN(Number(value)) ? 'Вкажіть число' : '';
  const getMovingCardError = (value) =>
    type === 'connected' && !value ? 'Поле обов’язкове' : '';
  const getThresholdError = (value) => {
    if (value === '' || value === null || value === undefined) return '';
    if (isNaN(Number(value))) return 'Вкажіть число';
    if (Number(value) > 50) return 'Максимальне значення - 50';
    return '';
  };

  const isFormInvalid =
    !!getNameError(form.name) ||
    !!getCapacityError(form.capacity) ||
    !!getThresholdError(form.threshold) ||
    (type === 'connected' && !!getMovingCardError(form.movingCard));

  const handleSubmit = () => {
    if (!isFormInvalid) {
      onSubmit(form);
    }
  };

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={setIsOpen}
      closeOnEscape
      closeOnInteractOutside
      trapFocus
      placement='center'
      motionPreset='slide-in-top'>
      <Portal>
        <Dialog.Backdrop backdropFilter='blur(8px)' />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Body mt='4'>
              <Button
                position='absolute'
                top={2}
                right={2}
                size='sm'
                variant='ghost'
                onClick={onClose}>
                {Close_Button_value}
              </Button>
              <Text fontWeight='bold' fontSize='lg' mb={6}>
                {isEdit
                  ? 'Редагувати бочку'
                  : type === 'main'
                    ? 'Створити головну бочку'
                    : 'Створити бочку для підключення'}
              </Text>
              <Flex direction='column' gap={4}>
                <Field.Root required>
                  <Field.Label>Назва</Field.Label>
                  <Input
                    name='name'
                    value={form.name}
                    onChange={handleChange}
                    placeholder='Назва бочки'
                    borderColor={
                      getNameError(form.name) ? 'red.500' : undefined
                    }
                  />
                  {getNameError(form.name) && (
                    <Text color='red.500' fontSize='12px'>
                      {getNameError(form.name)}
                    </Text>
                  )}
                </Field.Root>
                <Field.Root required>
                  <Field.Label>Об'єм (л)</Field.Label>
                  <Input
                    name='capacity'
                    type='number'
                    value={form.capacity}
                    onChange={handleChange}
                    placeholder="Об'єм"
                    borderColor={
                      getCapacityError(form.capacity) ? 'red.500' : undefined
                    }
                  />
                  {getCapacityError(form.capacity) && (
                    <Text color='red.500' fontSize='12px'>
                      {getCapacityError(form.capacity)}
                    </Text>
                  )}
                </Field.Root>
                <Field.Root>
                  <Field.Label>Поріг (необов'язково)</Field.Label>
                  <Input
                    name='threshold'
                    type='number'
                    value={form.threshold}
                    onChange={handleChange}
                    placeholder='Поріг попередження'
                    borderColor={
                      getThresholdError(form.threshold) ? 'red.500' : undefined
                    }
                  />
                  {getThresholdError(form.threshold) && (
                    <Text color='red.500' fontSize='12px'>
                      {getThresholdError(form.threshold)}
                    </Text>
                  )}
                </Field.Root>
                {type === 'connected' && (
                  <>
                    <SelectField
                      label='Картка переміщення'
                      value={form.movingCard}
                      collection={cardsCollection}
                      onChange={handleSelectChange}
                      placeholder='Оберіть картку'
                      isDisabled={!cardsCollection.items.length}
                    />
                    {touched.movingCard &&
                      !!getMovingCardError(form.movingCard) && (
                        <Text color='red.500' fontSize='sm' mt={1}>
                          Оберіть картку
                        </Text>
                      )}
                    {!cardsCollection.items.length && (
                      <Text color='gray.500' fontSize='sm' mt={1}>
                        Немає доступних карток
                      </Text>
                    )}
                  </>
                )}
              </Flex>
              <Box minW={{ base: '100%', md: '128px' }} mt={8}>
                <Button
                  onClick={handleSubmit}
                  fontWeight='bold'
                  fontSize='md'
                  w='full'
                  border='1px solid'
                  borderColor='gray.400'
                  boxShadow='md'
                  _hover={{ bg: 'gray.100', color: 'gray.900' }}
                  disabled={isFormInvalid}>
                  {isEdit ? 'Зберегти' : 'Створити'}
                </Button>
              </Box>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
